<template>
  <div class="drug-detail contant-wrap">
   <div class="filter-data">
      <h3>已退费</h3>
      <div class="filter-control">
        <el-row :gutter="40">
          <el-col :span="8">
            <div class="rows">
              <div class="fix-wrap">
                <label for="">退费日期：</label>
                <el-date-picker
                  class="container"
                  v-model="time"
                  type="daterange"
                  align="right"
                  :clearable="false"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @change="filterChange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows">
              <div class="fix-wrap">
                <label for="">医生：</label>
                <el-select v-model="query.doctorId" @change="filterChange" class="container" placeholder="请选择">
                  <el-option
                    v-for="item in doctorOptions"
                    :key="item.doctorId"
                    :label="item.realName"
                    :value="item.doctorId">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="rows">
              <div class="fix-wrap">
                <el-input placeholder="患者姓名" v-model="query.patient">
                  <el-button slot="append" icon="el-icon-search" @click="filterChange"></el-button>
                </el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-table :data="tableData" :header-cell-style="{background: '#ECEBEB', color: '#1A1A1A'}" style="width: 100%" class="table">
      <el-table-column prop="code" label="患者姓名">
        <template slot-scope="scope">
          {{scope.row.patient.patientName}}
        </template>
      </el-table-column>
      <el-table-column prop="gender" label="性别">
        <template slot-scope="scope">
          {{ scope.row.patient.gender | setGender}}
        </template>
      </el-table-column>
      <el-table-column prop="ageStr" label="就诊年龄">
      </el-table-column>
      <el-table-column prop="prescriptionAmount" label="诊断">
        <template slot-scope="scope">
          {{scope.row.inquiryInfo.diagnosisResultString}}
        </template>
      </el-table-column>
      <el-table-column prop="realName" label="医生">
      </el-table-column>
      <el-table-column prop="operateDate" label="退费日期">
      </el-table-column>
      <el-table-column prop="refundAmt" label="实退金额">
      </el-table-column>
      <el-table-column prop="operator" label="退费员">
      </el-table-column>
      <el-table-column prop="platForm" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="toRefundDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="tableData.length > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.currentPage"
        :page-sizes="pageSizes"
        :page-size.sync="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { pageSizes, pickerOptions, GENDER_OPTOINS } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize.js';
import { startDate, setToday } from '@/utils/filter';

export default {
  name: 'sale-drug',
  mixins: [ pageSize ],
  data() {
    return {
      pageSizes: pageSizes,
      pickerOptions:pickerOptions,
      doctorOptions: [],
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        patient: '', // 患者姓名
        startTime: '',
        endTime: '',
        doctorId: -1,
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      doctorOptions: [{
        doctorId: -1,
        realName: '全部',
      }],
    };
  },

  methods: {
    // 获取列表信息
    filterChange() {
      this.query.currentPage = 1,
      this.getTableData();
    },
    // 获取列表信息
    getTableData() {
      if (this.time) {
          this.query.startTime = this.time[0];
          this.query.endTime = this.time[1];
      } else {
          this.query.startTime = '';
          this.query.endTime = '';
      }
      this.$api.feeDispense.getRefund(this.query).then((res) => {
        
        this.tableData = res.order.map((item) => {
          let ageStr = '--';
          if (item.orderType === 1) {
            ageStr = item.inquiryInfo.clinicalAge ? item.inquiryInfo.clinicalAge : '--';
          } else {
            ageStr = item.patient.clinicalAge ? item.patient.clinicalAge : '--';
          }
          if(item.patient.patientName) {
            return {
              ...item,
              ageStr,
            };
          }
          return {
            ...item,
            ageStr,
            patient: {
              patientName: '--',
              age: '-',
              ageType: '--',
              gender: '--',
            },
            inquiryInfo: {
              diagnosisResultString: '--',
            },
          }
        });
        this.total = res.totalSize;
      })
    },
      // 每页展示数据条数变更
    handleSizeChange() {
      this.getTableData();
    },
    // 翻页
    handleCurrentChange() {
      this.getTableData();
    },
    toRefundDetail(item) {
      this.$router.push({name: 'returdDetail', query: {id: item.id}});
    },
    // 获取医生信息
    getDoctor() {
      this.$api.outPatient.getHospitalDoctor().then((res) => {
        // 先做默认第一个 后期本地存储一下
        this.doctorOptions = this.doctorOptions.concat(res);
      });
    },
    initQuery() {
      this.time = startDate(); // 设置默认日期
      this.query.patient = '';
      this.query.doctorId = -1;
      this.query.currentPage = 1;
    },
  },
  mounted() {
    this.time = startDate(); // 设置默认日期
    this.getTableData();
    this.getDoctor();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.initQuery();
      this.getTableData();
    }
    this.$route.meta.isBack = false;
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'returdDetail') {
      to.meta.isBack = true;
    }
    next();
  },
}
</script>

<style lang="scss" scoped>

</style>


